import React from "react";
import { Notification } from "@lib/types/Notification";
import { FormattedMessage, useIntl } from "react-intl";
import { getNotificationProps } from "@lib/helpers/notificationHelper";
import { useTypedSelector } from "@lib/redux";

export type NotificationMessageProps = {
  notification: Notification;
};

const NotificationMessage: React.FC<NotificationMessageProps> = (props) => {
  const { notification } = props;
  const { messages } = useIntl();
  const { role } = useTypedSelector((state) => state.auth?.user);

  const notificationProps = getNotificationProps({
    notification,
    role,
    messages,
  });

  const values = notificationProps?.description?.values;
  const tags = notificationProps?.description?.tags;

  const formattedValues = tags?.[0]
    ? Object.entries(values || {}).reduce(
        (acc, [key, value = " N/A "]) => {
          const tag = tags[0][key];
          if (tag) {
            acc[key] = React.createElement(tag, null, value);
          } else {
            acc[key] = value;
          }
          return acc;
        },
        {} as Record<string, string | number | null | React.ReactNode>,
      )
    : values;

  const message = messages[notificationProps.description.id] as string;
  const findKeys = message.match(/\{([^}]+)\}/g);
  const findKeysValues = findKeys?.reduce((acc, key) => {
    acc[key.replace("{", "").replace("}", "")] =
      formattedValues[key.replace("{", "").replace("}", "")]
        ?.toString()
        .replace("undefined", "") || " N/A ";
    return acc;
  }, {});

  return (
    <FormattedMessage
      id={notificationProps.description.id}
      values={{ ...findKeysValues, ...formattedValues }}
    />
  );
};

export default NotificationMessage;
